import { render, staticRenderFns } from "./ContactSvg.vue?vue&type=template&id=e355ebf4"
import script from "./ContactSvg.vue?vue&type=script&lang=js"
export * from "./ContactSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports